export enum ChartDrawerType {
  DonutChart,
  BarChart,
  HorizontalBarChart,
  GroupedBarChart,
  OverflowedHorizontalBarChart,
  SimpleDonutChart
}
